import React, { useState, useEffect } from "react";
import Button from "../../buttons/Button";
import "./style.css"; 

interface SplashScreenProps { 
  error: string|null;
  isLoading: boolean;
  isOffline: boolean;
  progress: number; 
  statusMessage: string;
  maxRetries: number;
  retryCount: number;
  restart: () => void;
}
export default function SplashScreen(props: SplashScreenProps) { 
  const { 
    error, 
    isLoading, 
    isOffline, 
    progress, 
    statusMessage, 
    maxRetries, 
    retryCount, 
    restart 
} = props;

  const [showSplash, setShowSplash] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if(!isLoading && progress === 100) {
      setIsFadingOut(true); 
      setTimeout(() => setShowSplash(false), 500); // Match this duration exactly with the CSS transition property (500ms)
    }
  }, [isLoading, progress]);

  // Completely wipe Splash out of the DOM after fade-out finishes
  if(!showSplash) {
    return null
  }

  const hasExceededRetryLimit = retryCount >= maxRetries;

  return (
    <div className={`splash-screen ${isFadingOut ? "fade-out" : ""}`}>
      <div className="logo-container">
        <img src="/images/branding/SecondaryLogo.png" alt="NearBuyCart Logo" className="splash-logo" />
      </div>

      { error && (
        <div className="splash-error-container">
          <p className="error-title">
            {isOffline ? "Network Offline" : "Initialization Failed"}
          </p>
          <p className="error-message">{error}</p>

          { isOffline && !hasExceededRetryLimit && (
            <div className="auto-retry-notice">
              <span className="pulse-dot"></span>
              <span>Waiting for a stable internet connection...</span>
            </div>
          )}

          { hasExceededRetryLimit && (
            <p className="retry-limit-warning">Auto-retry attempts exhausted.</p>
          )}
          
          <Button className="retry-button" onClick={restart}>
            Retry Manually {hasExceededRetryLimit ? "" : `(${retryCount}/${maxRetries})`}
          </Button>
        </div>
      )}
      
      { !error && ( 
        <div className="progress-container">
          <div className="progress-bar-track">
            <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
          </div>
          <div className="progress-text-row">
            <span className="status-message">{statusMessage}</span>
            <span className="percentage-counter">{progress}%</span>
          </div>
        </div>
      )}
    </div>
  );
};
